'use client';

// eslint-disable-next-line @alltrails/custom/client-navigation
import { useParams } from 'next/navigation';
import { getLanguageRegionCodeFromLocale } from '@alltrails/shared/utils/languageSupport';
import type { Locale } from '@alltrails/types/Locale';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import useRouter from './useRouter';

type Params = {
  locale: Locale;
};

export function useLanguageRegionCode(): LanguageRegionCode {
  const router = useRouter();
  const params = useParams<Params>();

  const locale = router ? (router.locale as Locale) : params?.locale;

  return getLanguageRegionCodeFromLocale(locale) || 'en-US';
}
